import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Calendar20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M6 8C6 8.55228 5.55228 9 5 9C4.44772 9 4 8.55228 4 8C4 7.44772 4.44772 7 5 7C5.55228 7 6 7.44772 6 8Z'
      fill='currentColor'
    />
    <path
      d='M10 9C10.5523 9 11 8.55228 11 8C11 7.44772 10.5523 7 10 7C9.44771 7 9 7.44772 9 8C9 8.55228 9.44771 9 10 9Z'
      fill='currentColor'
    />
    <path
      d='M6 12.5C6 13.0523 5.55228 13.5 5 13.5C4.44772 13.5 4 13.0523 4 12.5C4 11.9477 4.44772 11.5 5 11.5C5.55228 11.5 6 11.9477 6 12.5Z'
      fill='currentColor'
    />
    <path
      d='M10 13.5C10.5523 13.5 11 13.0523 11 12.5C11 11.9477 10.5523 11.5 10 11.5C9.44771 11.5 9 11.9477 9 12.5C9 13.0523 9.44771 13.5 10 13.5Z'
      fill='currentColor'
    />
    <path
      d='M16 8C16 8.55228 15.5523 9 15 9C14.4477 9 14 8.55228 14 8C14 7.44772 14.4477 7 15 7C15.5523 7 16 7.44772 16 8Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.75 2.25H13.25V1H14.75V2.25H18.4375C19.1312 2.25 19.75 2.79633 19.75 3.53846V16.4615C19.75 17.2037 19.1312 17.75 18.4375 17.75H1.5625C0.868834 17.75 0.25 17.2037 0.25 16.4615V3.53846C0.25 2.79633 0.868834 2.25 1.5625 2.25H5.25V1H6.75V2.25ZM5.25 3.75V5H6.75V3.75H13.25V5H14.75V3.75H18.25V16.25H1.75V3.75H5.25Z'
      fill='currentColor'
    />
  </Svg>
);

Calendar20.displayName = 'Calendar20';
export default Calendar20;
